module.exports = __webpack_public_path__ + "img/img-1.ea16a700.jpg";